import { createFileRoute } from "@tanstack/react-router";
import { FractionalCmoB2bSaas, b2bPage, specialistServiceSchema } from "@/pages/SpecialistCmoPages";
import { faqSchema, pageHead } from "@/lib/seo";

export const Route = createFileRoute("/fractional-cmo-b2b-saas")({
  head: () =>
    pageHead({
      path: b2bPage.path,
      title: b2bPage.title,
      description: b2bPage.description,
      crumbs: [["Fractional CMO B2B SaaS", "/fractional-cmo-b2b-saas"]],
      schemas: [...specialistServiceSchema(b2bPage), faqSchema(b2bPage.faq)],
    }),
  component: FractionalCmoB2bSaas,
});
